import { useGetApiV1GroupsByGroupIdMembershipQuery } from '../../api'

const useGroupMember = (groupId?: string) => {
  const {
    data: groupMember,
    isLoading,
    refetch,
  } = useGetApiV1GroupsByGroupIdMembershipQuery(
    {
      groupId: groupId!,
    },
    {
      skip: !groupId,
    },
  )

  return { groupMember, isLoading, refetchGroupMember: refetch }
}

export default useGroupMember
